export const activeNavState = {
  inviteGuest: 'invite_guest',
  addUser: 'add_user',
  inviteFriend: 'invite_friend',
};

export const allowedFileTypes = [
  { label: 'PDF', value: 'application/pdf' },
  { label: 'JPEG', value: 'image/jpeg' },
  { label: 'PNG', value: 'image/png' },
  { label: 'GIF', value: 'image/gif' },
];
